const TOKEN_KEY = 'biocon_admin_token';
const USERNAME_KEY = 'biocon_admin_user';

function parseJwtExpiry(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    let normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const pad = normalized.length % 4;
    if (pad) normalized += '='.repeat(4 - pad);
    const decoded = JSON.parse(atob(normalized)) as { exp?: unknown };
    return typeof decoded.exp === 'number' ? decoded.exp : null;
  } catch {
    return null;
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuth(token: string, username: string): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USERNAME_KEY, username);
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem(TOKEN_KEY);
}

/** 유효한 관리자 세션(토큰 존재 + 미만료) */
export function hasValidAdminSession(): boolean {
  const token = getToken();
  if (!token) return false;
  return !isTokenExpired(token);
}

export function isTokenExpired(token: string = getToken() ?? ''): boolean {
  if (!token) return true;
  const exp = parseJwtExpiry(token);
  if (exp === null) return false;
  return Date.now() >= exp * 1000;
}

export function getUsername(): string | null {
  return localStorage.getItem(USERNAME_KEY);
}
